import { Pipe, PipeTransform, inject } from '@angular/core';
import { GeneralUserService } from '@coin/shared/auth/data-access';
import { Observable, of } from 'rxjs';
import { Employee, EmptyGuid } from '@coin/shared/core/util-models';

@Pipe({
  name: 'employeeId$',
  standalone: true
})
export class EmployeeIdPipe implements PipeTransform {
  private readonly employeeService = inject(GeneralUserService);

  transform(id: string): Observable<Employee> {
    if (id && id !== EmptyGuid && id !== '-') {
      return this.employeeService.getEmployeeDetails(id);
    }
    return of(null);
  }
}
